import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import abda7b163cdadebe8cd2def60432c6e62b from "./generated-62daef5b-4a71-4e1c-a245-796789505dbb.json";

import a061cd4eba9ccdcdf1fb4f4bb63f2df58b from "./generated-a70564fe-f9e2-4ca6-9568-933992b53dac.json";

import a1bf6e15a66f2291bf452513fb4bfeaf0b from "./generated-d1c5d113-abec-4074-afeb-8e9824ca8263.json";

import a49d44c3acd6327b026f7cf4473f3292bb from "./generated-3f7738ec-f93d-423f-b4b6-04dfa711c0b9.json";

import a870ac06361434f35e7343dd34b518d03b from "./generated-9e5196f8-e1ba-4b26-8532-22f8d6442516.json";

import ae539d8daf477f18aa7cb6041b565dd6eb from "./generated-60765281-cc6d-4965-bec2-40e4d0ea4aab.json";

import a36578b0ff25be8384ae8e1ffc4aa71ddb from "./generated-247e436f-dd63-4824-bec2-5df91b4507c9.json";

import a06843ba82d5f024b4b63ad5d3b85861fb from "./generated-bd680ad7-a29b-480f-884a-5b476913a4a4.json";

import a498e4e7d9e2981f0db9f312ea0cc48efb from "./generated-55f5538f-070f-4869-9dff-bf4245ae98cf.json";

import a41b5a6e4730840bf0b5fcc68884c8d3db from "./generated-448b7b9d-4426-4cad-a3d2-782710671e71.json";

import a6b01aaf46968885c8ccc5e63570fb8ceb from "./generated-343fc08d-b074-4d4d-a325-ee20fc59d151.json";

import a43e09b1cb1045530407968fee1ee139eb from "./generated-191cbbe9-5272-4625-b8f6-80de9d5d7bd6.json";

import a6a2d2d819ff9295f0650268a2f10070eb from "./generated-d7581e81-986a-48c8-9590-b3493d92bf93.json";

import afedf259626d0935d90d4c2745ef46761b from "./generated-258e0e33-0628-43ec-8b4b-2c4d610b22e2.json";

import aa5aa87f6577a31361e4541d7123a8649b from "./generated-5a879da2-cb4f-49a6-a9fc-a412ad397fcf.json";

import afb05125a4eac6d44576a648c67beddceb from "./generated-8ccd0ebf-7708-4e43-a8fc-ffd649c1745d.json";

import a00d3636c2db5be95704cd1b19f679fceb from "./generated-534ff6ed-9507-45a6-9842-71db18a05a08.json";

import ac34668d2c31a82de870ed5c11bed4fa6b from "./generated-36e098e1-aec2-4b77-93ec-3d7a04c02740.json";

import a0f05ed36ce6a3b9f8b60fb4ca8d2f45cb from "./generated-324c9852-2fec-4a2e-9fd5-909095aeb13c.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(abda7b163cdadebe8cd2def60432c6e62b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a061cd4eba9ccdcdf1fb4f4bb63f2df58b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a1bf6e15a66f2291bf452513fb4bfeaf0b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a49d44c3acd6327b026f7cf4473f3292bb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a870ac06361434f35e7343dd34b518d03b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(ae539d8daf477f18aa7cb6041b565dd6eb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a36578b0ff25be8384ae8e1ffc4aa71ddb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a06843ba82d5f024b4b63ad5d3b85861fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a498e4e7d9e2981f0db9f312ea0cc48efb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a41b5a6e4730840bf0b5fcc68884c8d3db);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6b01aaf46968885c8ccc5e63570fb8ceb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a43e09b1cb1045530407968fee1ee139eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a6a2d2d819ff9295f0650268a2f10070eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(afedf259626d0935d90d4c2745ef46761b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aa5aa87f6577a31361e4541d7123a8649b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(afb05125a4eac6d44576a648c67beddceb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a00d3636c2db5be95704cd1b19f679fceb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ac34668d2c31a82de870ed5c11bed4fa6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0f05ed36ce6a3b9f8b60fb4ca8d2f45cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a00d3636c2db5be95704cd1b19f679fceb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */